import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { spikeSearchModalTranslationRef } from '../translation';

export const spikeSearchModalTranslations = createTranslationResource({
  ref: spikeSearchModalTranslationRef,
  translations: {
    'pt-BR': async () => {
      const m = await import('./pt-BR.json');
      return {
        default: createTranslationMessages({
          ref: spikeSearchModalTranslationRef,
          full: false,
          messages: m.default,
        }),
      };
    },
  },
});
